import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../src/store/account.ts'), 'account.ts')
  resolveStoreModules(require('../src/store/acts.ts'), 'acts.ts')
  resolveStoreModules(require('../src/store/additionalAgreement.ts'), 'additionalAgreement.ts')
  resolveStoreModules(require('../src/store/agencies.ts'), 'agencies.ts')
  resolveStoreModules(require('../src/store/authActions.ts'), 'authActions.ts')
  resolveStoreModules(require('../src/store/authStore.ts'), 'authStore.ts')
  resolveStoreModules(require('../src/store/cities.ts'), 'cities.ts')
  resolveStoreModules(require('../src/store/citiesDADATA.ts'), 'citiesDADATA.ts')
  resolveStoreModules(require('../src/store/client.ts'), 'client.ts')
  resolveStoreModules(require('../src/store/clients.ts'), 'clients.ts')
  resolveStoreModules(require('../src/store/commercial.ts'), 'commercial.ts')
  resolveStoreModules(require('../src/store/deal.ts'), 'deal.ts')
  resolveStoreModules(require('../src/store/discount.ts'), 'discount.ts')
  resolveStoreModules(require('../src/store/documents.ts'), 'documents.ts')
  resolveStoreModules(require('../src/store/events.ts'), 'events.ts')
  resolveStoreModules(require('../src/store/featureFlags.ts'), 'featureFlags.ts')
  resolveStoreModules(require('../src/store/fired.ts'), 'fired.ts')
  resolveStoreModules(require('../src/store/flat.ts'), 'flat.ts')
  resolveStoreModules(require('../src/store/global.ts'), 'global.ts')
  resolveStoreModules(require('../src/store/images.ts'), 'images.ts')
  resolveStoreModules(require('../src/store/interaction.ts'), 'interaction.ts')
  resolveStoreModules(require('../src/store/knowledge.ts'), 'knowledge.ts')
  resolveStoreModules(require('../src/store/mainPage.ts'), 'mainPage.ts')
  resolveStoreModules(require('../src/store/manuals.ts'), 'manuals.ts')
  resolveStoreModules(require('../src/store/meetings.ts'), 'meetings.ts')
  resolveStoreModules(require('../src/store/menu.ts'), 'menu.ts')
  resolveStoreModules(require('../src/store/notifications.ts'), 'notifications.ts')
  resolveStoreModules(require('../src/store/onboarding.ts'), 'onboarding.ts')
  resolveStoreModules(require('../src/store/projects.ts'), 'projects.ts')
  resolveStoreModules(require('../src/store/property.ts'), 'property.ts')
  resolveStoreModules(require('../src/store/registration.ts'), 'registration.ts')
  resolveStoreModules(require('../src/store/survey.ts'), 'survey.ts')
  resolveStoreModules(require('../src/store/templates.ts'), 'templates.ts')
  resolveStoreModules(require('../src/store/warning.ts'), 'warning.ts')
  resolveStoreModules(require('../src/store/loyalty/index.ts'), 'loyalty/index.ts')
  resolveStoreModules(require('../src/store/contract/index.ts'), 'contract/index.ts')
  resolveStoreModules(require('../src/store/calendar/index.ts'), 'calendar/index.ts')
  resolveStoreModules(require('../src/store/buildings/index.ts'), 'buildings/index.ts')
  resolveStoreModules(require('../src/store/agentProfile/index.ts'), 'agentProfile/index.ts')
  resolveStoreModules(require('../src/store/additionalAgreements/index.ts'), 'additionalAgreements/index.ts')
  resolveStoreModules(require('../src/store/acts/acts.ts'), 'acts/acts.ts')
  resolveStoreModules(require('../src/store/acts/prepareAct.ts'), 'acts/prepareAct.ts')
  resolveStoreModules(require('../src/store/acts/types.ts'), 'acts/types.ts')
  resolveStoreModules(require('../src/store/agentProfile/agentProfile.ts'), 'agentProfile/agentProfile.ts')
  resolveStoreModules(require('../src/store/agentProfile/types.ts'), 'agentProfile/types.ts')
  resolveStoreModules(require('../src/store/agents/agents.ts'), 'agents/agents.ts')
  resolveStoreModules(require('../src/store/agents/types.ts'), 'agents/types.ts')
  resolveStoreModules(require('../src/store/buildings/buildings.ts'), 'buildings/buildings.ts')
  resolveStoreModules(require('../src/store/buildings/types.ts'), 'buildings/types.ts')
  resolveStoreModules(require('../src/store/calendar/filters.ts'), 'calendar/filters.ts')
  resolveStoreModules(require('../src/store/collection/collection.ts'), 'collection/collection.ts')
  resolveStoreModules(require('../src/store/collection/dealCollections.ts'), 'collection/dealCollections.ts')
  resolveStoreModules(require('../src/store/collection/managerCollections.ts'), 'collection/managerCollections.ts')
  resolveStoreModules(require('../src/store/collection/sentCollections.ts'), 'collection/sentCollections.ts')
  resolveStoreModules(require('../src/store/collection/types.ts'), 'collection/types.ts')
  resolveStoreModules(require('../src/store/contract/lib.ts'), 'contract/lib.ts')
  resolveStoreModules(require('../src/store/contract/types.ts'), 'contract/types.ts')
  resolveStoreModules(require('../src/store/deal/booking.ts'), 'deal/booking.ts')
  resolveStoreModules(require('../src/store/deal/documents.ts'), 'deal/documents.ts')
  resolveStoreModules(require('../src/store/deals/dealsPinia.ts'), 'deals/dealsPinia.ts')
  resolveStoreModules(require('../src/store/deals/types.ts'), 'deals/types.ts')
  resolveStoreModules(require('../src/store/deals/utils.ts'), 'deals/utils.ts')
  resolveStoreModules(require('../src/store/loyalty/lib.ts'), 'loyalty/lib.ts')
  resolveStoreModules(require('../src/store/loyalty/types.ts'), 'loyalty/types.ts')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs|ts)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const propertyStoreModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(propertyStoreModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
